<template>
  <div class="main user-page">
    <!-- Left -->
    <div class="main_l">
      <Organization @change="changeOrganization"></Organization>
    </div>
    <!-- Left End -->

    <!-- Right -->
    <div class="main_r" ref="pageBody">
      <div class="page-top">
        <div class="title_line">用户管理列表</div>

        <div class="filter-strip">
          <div class="filter-strip__fields">
            <div class="filter-field">
              <label class="filter-field__label">人员名称</label>
              <el-input v-model="keyword" placeholder="查找人员名称" clearable size="small"></el-input>
            </div>
            <div class="filter-field">
              <label class="filter-field__label">角色</label>
              <el-select v-model="role_id" placeholder="请选择角色" size="small">
                <el-option label="请选择角色" value="-1"></el-option>
                <el-option v-for="item in role_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="filter-field">
              <label class="filter-field__label">人员状态</label>
              <el-select v-model="user_status" placeholder="请选择人员状态" size="small">
                <el-option label="请选择人员状态" value="-1"></el-option>
                <el-option label="在职" value="1"></el-option>
                <el-option label="离职" value="0"></el-option>
              </el-select>
            </div>
          </div>
          <div class="filter-strip__actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
            <span class="filter-strip__sep"></span>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="clickdialogAddUser">新增</el-button>
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <div class="table-section">
        <div class="table-container" ref="tableContainer">
          <el-table :data="dataList" class="user-table" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
            <el-table-column prop="id" label="序号" width="80" sortable="custom"></el-table-column>
            <el-table-column prop="userLogin" label="登录账号" sortable="custom"></el-table-column>
            <el-table-column prop="userName" label="人员姓名" sortable="custom"></el-table-column>
            <el-table-column prop="userPhone" label="联系方式" sortable="custom"></el-table-column>
            <el-table-column prop="Role" label="角色" sortable="custom">
              <template slot-scope="props">
                <span v-for="item in role_list" :key="item.id" v-if="item.id == props.row.roleId">{{item.name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="userStatus" label="人员状态" sortable="custom" align="center">
              <template slot-scope="props">
                <el-tag v-if="props.row.userStatus == 1" type="success" size="small" effect="plain">在职</el-tag>
                <el-tag v-if="props.row.userStatus == 0" type="info" size="small" effect="plain">离职</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="Operation" label="操作" width="120" align="center">
              <template slot-scope="props">
                <div class="action-group">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-edit" @click="clickdialogEdit(props.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip v-if="props.row.userStatus == 0" class="item" effect="dark" content="离职" placement="top" :enterable="false">
                    <el-link :underline="false" icon="el-icon-lock" @click="ClickLock(props.row,1)"></el-link>
                  </el-tooltip>
                  <el-tooltip v-if="props.row.userStatus == 1" class="item" effect="dark" content="在职" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-unlock" @click="ClickLock(props.row,0)"></el-link>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 列表 End -->

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="10"
          layout="total, prev, pager, next, sizes, jumper"
          :total="dataListnum">
        </el-pagination>
      </div>
      <!-- 分页 End -->
    </div>
    <!-- Right End -->

    <!---------------------- 以下是弹框内容 ---------------------->
    <!-- 新增用户 -->
    <el-dialog title="添加人员" :visible.sync="dialogAddUser" width="26%" class="newAdd">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="addData" label-width="80px">
          <el-form-item label="账号" :required=true>
            <el-input v-model="addData.userLogin" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码" :required=true>
            <el-input v-model="addData.userPassword" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="姓名" :required=true>
            <el-input v-model="addData.userName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" :required=true>
            <el-input v-model="addData.userPhone" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="角色" :required=true>
            <el-select v-model="addData.roleId" placeholder="角色">
              <el-option label="请选择" value="-1"></el-option>
              <el-option v-for="item in role_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser()" >确定</el-button>
        <el-button @click="dialogAddUser = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 新增用户 End -->

    <!-- 编辑信息 -->
    <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="26%" class="newAdd">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="editData" label-width="80px">
          <el-form-item label="密码">
            <el-input v-model="editData.userPassword" placeholder="仅需修改密码时填写"></el-input>
          </el-form-item>
          <el-form-item label="姓名" :required=true>
            <el-input v-model="editData.userName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" :required=true>
            <el-input v-model="editData.userPhone" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="角色" :required=true>
            <el-select v-model="editData.roleId" placeholder="角色">
              <el-option label="请选择" value="-1"></el-option>
              <el-option v-for="item in role_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editUser()" >确定</el-button>
        <el-button @click="dialogEdit = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑信息 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import Organization from '@/components/Organization.vue' // 组织架构
Vue.use(VueAxios, axios)

export default {
  components: { Organization },
  data () {
    return {
      formLabelWidth: '120px',
      keyword: '',
      role_list: [],
      role_id: '-1',
      user_status: '-1',
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      organizationId: '',
      // 新增
      dialogAddUser: false,
      addData: {
        userLogin: '',
        userPassword: '',
        userName: '',
        userPhone: '',
        roleId: ''
      },
      // 编辑
      dialogEdit: false,
      editData: {
        editId: '',
        userPassword: '',
        userName: '',
        userPhone: '',
        roleId: ''
      }
    }
  },
  mounted () {
    this.listRole()
  },
  methods: {
    handleSizeChange (val) {
      this.page_size = val
      this.getUsersByCombinationConditions()
      this.getUsersNumByCombinationConditions()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.getUsersByCombinationConditions()
      this.getUsersNumByCombinationConditions()
    },
    handleSortChange ({ prop, order }) {
      const fieldMap = {
        'Role': 'roleId'
      }
      this.sortField = fieldMap[prop] || prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.getUsersByCombinationConditions()
      this.getUsersNumByCombinationConditions()
    },
    changeOrganization (node) {
      this.organizationId = node.id
      this.getUsersByCombinationConditions()
      this.getUsersNumByCombinationConditions()
    },
    clickQuery () {
      this.page_no = 1
      this.getUsersByCombinationConditions()
      this.getUsersNumByCombinationConditions()
    },
    clickQueryReset () {
      this.keyword = ''
      this.role_id = '-1'
      this.user_status = '-1'
      this.clickQuery()
    },
    clickdialogAddUser () {
      this.dialogAddUser = true
      this.addData.userLogin = ''
      this.addData.userPassword = ''
      this.addData.userName = ''
      this.addData.userPhone = ''
      this.addData.roleId = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.editId = row.id
      this.editData.userPassword = ''
      this.editData.userName = row.userName
      this.editData.userPhone = row.userPhone
      this.editData.roleId = row.roleId
    },
    ClickLock (row, userStatus) {
      this.editUserStatus(row.id, userStatus)
    },
    listRole: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_listRole, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.role_list = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getUsersByCombinationConditions: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.organizationId = that.organizationId
      data.keyword = that.keyword
      data.roleId = that.role_id
      data.userStatus = that.user_status
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_getUsersByCombinationConditions, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getUsersNumByCombinationConditions: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.organizationId = that.organizationId
      data.keyword = that.keyword
      data.roleId = that.role_id
      data.userStatus = that.user_status
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_getUsersNumByCombinationConditions, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    addUser: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.userLogin = that.addData.userLogin
      data.userPassword = that.addData.userPassword
      data.userName = that.addData.userName
      data.userPhone = that.addData.userPhone
      data.organizationId = that.organizationId
      data.roleId = that.addData.roleId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_addUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.getUsersByCombinationConditions()
            that.getUsersNumByCombinationConditions()
            that.dialogAddUser = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAddUser = false
        })
    },
    editUser: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.editId = that.editData.editId
      data.userPassword = that.editData.userPassword
      data.userName = that.editData.userName
      data.userPhone = that.editData.userPhone
      data.roleId = that.editData.roleId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_editUser, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.getUsersByCombinationConditions()
            that.getUsersNumByCombinationConditions()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    editUserStatus: function (editId, userStatus) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.editId = editId
      data.userStatus = userStatus
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_editUserStatus, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.getUsersByCombinationConditions()
            that.getUsersNumByCombinationConditions()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  UserManagement · 统一设计规范 v1.0
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.user-page {
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;
}

.main_r {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  padding: 16px 20px 14px;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;

  /deep/ .el-input,
  /deep/ .el-select {
    width: 100%;
  }
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

.filter-strip__sep {
  width: 1px;
  height: 24px;
  background: var(--aptus-border);
  margin: 0 2px;
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}

/* 用户表格 */
.user-table {
  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: nowrap;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--primary:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--danger:hover {
      background-color: var(--aptus-danger-bg);
    }

    &.el-link--success:hover {
      background-color: var(--aptus-success-bg);
    }
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 1200px) {
  .filter-strip__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .main_r {
    padding: 10px;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr 1fr;
  }
}

/* 通用表单 */
.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: var(--aptus-surface-muted);
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: #A8D0F5;

  &:hover {
    background: var(--aptus-primary);
    color: #FFF;
    border-color: var(--aptus-primary);
  }
}
</style>
